import React from 'react';
import { TONE_CHIP } from '../../../lib/rcu/catalog/feedback';
import type { Tone } from '../../../lib/rcu/catalog/feedback';

export interface ChipProps {
  label: string;
  tone?: Tone;
  className?: string;
}

/** Small status badge. Tone decides the colours, so lists read consistently. */
export const Chip: React.FC<ChipProps> = ({ label, tone, className = '' }) => (
  <span
    className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
      tone === undefined ? TONE_CHIP.neutral : TONE_CHIP[tone]
    } ${className}`}
  >
    {label}
  </span>
);

export default Chip;
